import React, { Fragment, useState, useEffect } from "react";
import { set_return_detail } from "../../../redux/actions/ReturnsAction";
import { connect } from "react-redux";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import { set_loading } from "../../../redux/actions/LayoutAction";

import Header from "../subheader/Header";
import "./viewreturn.scss";
import { format } from "date-fns";
import { FaWallet } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { getDesktopImage } from "../../../utils/utils";

const ViewReturn = (props) => {
  const [data, setData] = useState(false);
  const param = useParams();
  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    document.title = "Return";
  }, []);

  useEffect(() => {
    apiJson.returns.getReturnDetail(parseInt(param.id)).then((response) => {
      if (response.success) {
        props.set_return_detail({ returnDetail: response.data });

        setData(true);
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
        setData(false);
      } else {
        setData(false);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }, []);

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <Fragment>
      <div className="vendor-page-right view-return-page-desktop">
        <Header heading="View Return" search={false} filters={null} />
        <div className="right-content view-return-page-content-container">
          {data && (
            <div className="content-container view-return-content-wrapper">
              <div className="content-wrapper mx-auto">
                <div className="return-header mx-0 d-flex">
                  <div className="return-head-text">
                    Return ID: {props.returnDetail.id}
                  </div>
                  <div className="return-fade-text">
                    Placed on:
                    {props.returnDetail &&
                      props.returnDetail.created_at &&
                      props.returnDetail.created_at !== "" &&
                      format(
                        Date.parse(props.returnDetail.created_at),
                        "dd MMM yyy p"
                      )}
                  </div>
                </div>
                <div className="return-detail-box">
                  <div className="first-box d-flex">
                    <div className="return-details">
                      <h5 className="return-head-text">Pickup Address</h5>
                      <div className="return-fade-text name">
                        <p>
                          {props.returnDetail && props.returnDetail.address
                            ? props.returnDetail.address.first_name &&
                              props.returnDetail.address.first_name 
                              // +
                              //   props.returnDetail.address.last_name &&
                              // props.returnDetail.address.last_name
                            : ""}
                        </p>
                        <p>
                          {" "}
                          {props.returnDetail && props.returnDetail.address
                            ? props.returnDetail.address.address1 &&
                              props.returnDetail.address.address1
                            : ""}
                        </p>
                        <p>
                          {props.returnDetail && props.returnDetail.address
                            ? props.returnDetail.address.contact_number &&
                              props.returnDetail.address.contact_number
                            : ""}
                        </p>
                      </div>
                    </div>
                    {props.returnDetail?.status !== "rejected" && (
                      <div className="return-method">
                        <div className="return-head-text">Refund Method</div>
                        <div className="payment-method d-flex align-items-center">
                          <div className="icon">
                            <FaWallet />
                          </div>
                          {(props.returnDetail?.status === "requested" ||
                            props.returnDetail?.status === "approved") && (
                            <div className="text">
                              {props.returnDetail?.refund_method === "bank"
                                ? "Only the amount paid with credit/debit card can be refunded to bank, remaining amount will be refunded to wallet."
                                : "Will be refunded to wallet"}
                            </div>
                          )}
                          {props.returnDetail?.status === "completed" && (
                            <div className="text">
                              Refunded to{" "}
                              {props.returnDetail?.refund_method
                                ? props.returnDetail?.refund_method
                                : "wallet"}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="second-box row d-flex align-items-center">
                    <div className="detail-col col-lg-7 col-md-8 d-flex align-items-center">
                      <div className="image-col">
                        {(props.returnDetail?.line_item
                          ?.featured_image_resized ||
                          props.returnDetail?.line_item?.featured_image) && (
                          <img
                            src={getDesktopImage(
                              props.returnDetail?.line_item
                                ?.featured_image_resized,
                              props.returnDetail?.line_item?.featured_image
                            )}
                            alt=""
                            style={{
                              width: "auto",
                              maxWidth: "100%",
                              heigth: "110px",
                            }}
                          />
                        )}
                      </div>
                      <div className="description-col d-flex flex-column">
                        {props.returnDetail?.line_item?.brand_name_en && (
                          <div className="return-fade-text mb-1 text-capitalize">
                            {props.returnDetail?.line_item?.brand_name_en}
                          </div>
                        )}
                        {props.returnDetail?.line_item?.product_name_en && (
                          <div className="return-text mb-1">
                            {props.returnDetail?.line_item?.product_name_en +
                              " "}
                            {props.returnDetail?.line_item?.variant_name_en}
                          </div>
                        )}
                        {props.returnDetail?.line_item?.service_name_en && (
                          <div className="return-text mb-1">
                            {props.returnDetail?.line_item?.service_name_en}
                          </div>
                        )}
                        {props.returnDetail?.line_item?.sku && (
                          <div className="return-fade-text mb-1">
                            {props.returnDetail?.line_item?.sku}
                          </div>
                        )}
                        <div className="return-text">
                          <span className="text-uppercase">
                            {props.returnDetail?.line_item?.currency
                              ? props.returnDetail?.line_item?.currency
                              : ""}
                          </span>
                          <span className="font-weight">
                            {props.returnDetail?.line_item?.sale_price}
                          </span>
                          {parseFloat(
                            props.returnDetail?.line_item?.sale_price
                          ) <
                            parseFloat(
                              props.returnDetail?.line_item?.price
                            ) && (
                            <span className="ms-2 text-uppercase">
                              <small>
                                <del>
                                  {" "}
                                  {props.returnDetail?.line_item?.currency +
                                    " " +
                                    props.returnDetail?.line_item?.price}
                                </del>
                              </small>
                            </span>
                          )}
                        </div>
                        <div className="return-text">
                          Sold by
                          <span className="font-weight">
                            {props.returnDetail &&
                            props.returnDetail.line_item &&
                            props.returnDetail.line_item.store_name_en
                              ? props.returnDetail.line_item.store_name_en
                              : ""}
                          </span>
                        </div>
                        <div className="return-text">
                          <span className="return-fade-text">Reason</span>
                          {props.returnDetail && props.returnDetail.reason
                            ? props.returnDetail.reason
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div className="status-col g-0 col-lg-5 col-md-4 ">
                      <div className="admin-status ">
                        <span className="role">Status</span>
                        <span className="response text-uppercase">
                          {props.returnDetail?.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    returnDetail: state.return.returnDetail,
    load: state.layout.isLoading,
  };
};

const mapDispatchTopProps = { set_return_detail, set_loading };

export default connect(mapStateToProps, mapDispatchTopProps)(ViewReturn);
